import PropTypes from "prop-types";
import {
  APP_LOGO_ALT,
  APP_LOGO_URL,
  SIDEBAR_LOGO_URL,
} from "../../Constants/branding";

const VARIANTS = {
  auth: {
    wrap: "flex flex-col items-center justify-center gap-2 w-full",
    image: "h-16 w-auto max-w-[120px] object-contain",
    text: "text-[18px] sm:text-[20px] font-semibold text-main tracking-tight",
  },
  sidebar: {
    wrap: "flex items-center gap-2 min-w-0 flex-1 overflow-hidden",
    imageWrap:
      "h-11 w-11 shrink-0 rounded-[8px] bg-white p-[3px] flex items-center justify-center shadow-sm",
    image: "h-full w-full object-contain",
    text: "text-[14px] font-semibold text-white leading-[1.2] tracking-tight text-left min-w-0",
  },
  "sidebar-collapsed": {
    wrap: "flex items-center justify-center",
    imageWrap:
      "h-11 w-11 shrink-0 rounded-[8px] bg-white p-[3px] flex items-center justify-center shadow-sm",
    image: "h-full w-full object-contain",
    text: "",
  },
  header: {
    wrap: "flex items-center gap-2 min-w-0",
    imageWrap:
      "h-10 w-10 shrink-0 rounded-[8px] bg-white flex items-center justify-center",
    image: "h-10 w-10 object-contain",
    text: "hidden min-[420px]:block text-[12px] font-semibold text-main leading-[1.15] tracking-tight text-left min-w-0",
  },
};

function BrandTitle({ className, stacked = false }) {
  if (stacked) {
    return (
      <p className={className}>
        <span className="block">Western Railway</span>
        <span className="block font-medium opacity-90">Waterlogging</span>
      </p>
    );
  }

  return (
    <p className={className}>
      Western Railway <span className="opacity-70 font-medium">|</span>{" "}
      Waterlogging
    </p>
  );
}

const AppBrandMark = ({ variant = "auth", className = "" }) => {
  const styles = VARIANTS[variant] ?? VARIANTS.auth;
  const showText = variant !== "sidebar-collapsed";
  const logoUrl =
    variant === "sidebar" ||
    variant === "sidebar-collapsed" ||
    variant === "header"
      ? SIDEBAR_LOGO_URL
      : APP_LOGO_URL;

  return (
    <div className={`${styles.wrap} ${className}`.trim()}>
      {styles.imageWrap ? (
        <span className={styles.imageWrap}>
          <img src={logoUrl} alt={APP_LOGO_ALT} className={styles.image} />
        </span>
      ) : (
        <img src={logoUrl} alt={APP_LOGO_ALT} className={styles.image} />
      )}
      {showText ? (
        <BrandTitle
          className={styles.text}
          stacked={variant === "sidebar" || variant === "header"}
        />
      ) : null}
    </div>
  );
};

AppBrandMark.propTypes = {
  variant: PropTypes.oneOf(["auth", "sidebar", "sidebar-collapsed", "header"]),
  className: PropTypes.string,
};

export default AppBrandMark;
export { BrandTitle };
